import React from 'react';

import { getAssetUrl, getPageOverlay, hasPageOverlays } from 'editor-utils/template';

import withPageStyle, { PagePropTypes } from './index';
import PlaceholderThumb from '../placeholder/thumb';
import PageLayer from '../placeholder/layer';

const PageThumb = props => {
  const { page, template } = props;

  let pageOverlay;
  if (hasPageOverlays(page)) {
    // TODO we need to support more types of overlays
    pageOverlay = getPageOverlay(page);
  }

  return (
    <>
      {page.placeholders.map(placeholder => {
        const { override } = placeholder;

        return (
          <PlaceholderThumb
            key={placeholder.id}
            placeholder={{ ...placeholder, ...override }}
            page={page}
            template={template}
          />
        );
      })}

      {pageOverlay && (
        <PageLayer
          src={`${getAssetUrl(template, `/assets_client/pages/${pageOverlay}.png`)}?_`}
          className="editor-page-overlay"
        />
      )}
    </>
  );
};

PageThumb.propTypes = {
  ...PagePropTypes,
};

export default withPageStyle(PageThumb);
